// extracted by mini-css-extract-plugin
export var dietary = "RegistrationFormSingapore-module--dietary--315e7";
export var formSubmit = "RegistrationFormSingapore-module--formSubmit--5b3b1";
export var holder = "RegistrationFormSingapore-module--holder--a3549";
export var info = "RegistrationFormSingapore-module--info--5a044";
export var location = "RegistrationFormSingapore-module--location--a910f";
export var registrationFormWrapper = "RegistrationFormSingapore-module--registrationFormWrapper--97b29";
export var submit = "RegistrationFormSingapore-module--submit--a4ef3";
export var wrapper = "RegistrationFormSingapore-module--wrapper--f69a7";